import {
  ListManager,
  PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import clients from '@/services/api/clients'
import React from 'react'
import FormClient from '../Form'
import Row from '../Row'

function List({ title }) {
  usePageTitle({ title })

  const {
    data, loading, error, setData,
  } = useAxiosRequest(clients.list)

  function onAdded(client) {
    setData((prevData) => [client, ...(prevData ?? [])])
  }

  function onUpdate(client) {
    setData((prevData) => prevData.map((c) => (c.id === client.id ? client : c)))
  }

  function onRemoved(client) {
    setData((prevData) => prevData.filter((c) => c.id !== client.id))
  }

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Lista de clients"
        icon="fas fa-cogs"
        rightAction={() => <FormClient onAdded={onAdded} />}
      />

      <ListManager count={data?.length ?? 0} loading={loading} error={error}>
        {
          Boolean(data) && (
            <table className="table text-small table-hover">
              <thead>
                <tr>
                  <th>Client ID</th>
                  <th>Nome</th>
                  <th>Secret</th>
                  <th>Status</th>
                  <th className="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                {
                  data.map((client) => (
                    <Row
                      client={client}
                      key={client.id}
                      onUpdate={onUpdate}
                      onRemoved={onRemoved}
                    />
                  ))
                }
              </tbody>
            </table>
          )
        }
      </ListManager>
    </Styles.Container>
  )
}

export default List
